<template>
  <HdNotifications :notifications="notifications" class="service-worker-notifications">
    <template #default="{ notification }">
      <NotificationItem :notification="notification" />
    </template>
  </HdNotifications>
</template>

<script>
import { HdNotifications, HdNotificationsTypes } from 'homeday-blocks';
import NotificationItem from '@/components/NotificationItem.vue';
import { SERVICE_WORKER_STATUS } from '@/config/CONSTANTS';

export default {
  name: 'ServiceWorkerNotifications',
  components: {
    HdNotifications,
    NotificationItem,
  },
  computed: {
    notifications() {
      const notifications = [];

      if (this.$store.state.serviceWorkerStatus === SERVICE_WORKER_STATUS.UPDATED) {
        notifications.push(this.getUpdatedNotification());
      }

      return notifications;
    },
  },
  methods: {
    getUpdatedNotification() {
      return {
        type: HdNotificationsTypes.SUCCESS,
        message: this.$t('SERVICE_WORKER.UPDATED.MESSAGE'),
        buttonLabel: this.$t('SERVICE_WORKER.UPDATED.BUTTON_LABEL'),
        buttonAction: this.updateServiceWorkerAndRefresh,
      };
    },
    async updateServiceWorkerAndRefresh() {
      try {
        const serviceWorkerRegistration = await navigator.serviceWorker.ready;
        const waitingServiceWorker = serviceWorkerRegistration.waiting;

        // Service worker in control of the page has changed which means
        // that the waiting service worker is ready and we can use it
        navigator.serviceWorker.addEventListener('controllerchange', this.refresh);

        waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      } catch (e) {
        this.refresh();
      }
    },
    refresh() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.service-worker-notifications {
  &__item {
    cursor: pointer;
    box-shadow: inset 0 -2px 0 0 currentColor;
  }
}
</style>
